import type { ProductListingLiveEntry } from "../content-blocks/product-listing-block.client.preview";
import { ProductListingBlockClientPreview } from "../content-blocks/product-listing-block.client.preview";
import type { ProductListingBlockProps } from "./product-listing-block";
import { buildProductListingClientProps } from "./product-listing-block";

export async function ProductListingBlockPreview(
  props: Readonly<ProductListingBlockProps>
) {
  const clientProps = await buildProductListingClientProps(
    props,
    "ProductListingBlockPreview"
  );

  if (!clientProps) {
    return null;
  }

  const liveEntry: ProductListingLiveEntry = {
    __typename: "ProductListing",
    sys: props.sys,
    internalName: props.internalName,
    title: props.title,
    anchorId: props.anchorId,
    productCategory: props.productCategory,
    defaultSort: props.defaultSort,
    searchQuery: props.searchQuery,
    showFilters: props.showFilters,
    showSorting: props.showSorting,
    paginationMode: props.paginationMode,
    pageSize: props.pageSize,
  };

  return (
    <ProductListingBlockClientPreview {...clientProps} liveEntry={liveEntry} />
  );
}
